import { type Building } from "@eisox/api/core-api";

import type { EnhancedRoom } from "~/types/room.type";

import { getTemperature, type PlanningType } from "./planning.helper";

/**
 * Calculates the consign temperature based on the current time slot, house, room, and other factors.
 * @returns The consign temperature.
 */
export const getSetpointTemp = (
  building: Building,
  room: EnhancedRoom,
  currentTimeSlotTypeForConsign: PlanningType,
  swOffsetEnabled: boolean,
  swOffset: number,
): number | undefined => {
  const tempCurrentTimeSlot = getTemperature(building, room, currentTimeSlotTypeForConsign);
  if (!tempCurrentTimeSlot) return undefined;
  const swOffsetTemp = swOffsetEnabled && swOffset ? swOffset : 0;
  return tempCurrentTimeSlot + swOffsetTemp;
};
